/**
 * Created by liuxi on 2023/12/21 18:52
 */
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

interface IProps {
  to: string
}

const Redirect: React.FC<IProps> = (props) => {
  const navigate = useNavigate()
  useEffect(() => {
    navigate(props.to)
  })
  return null
}

export default Redirect
